export const head=[
	{
		name:'ASN日期',
		Display:'送货单日期',
		type:1,
		disabled:true
	},
	{
		name:'ASN单号',
		Display:'送货单号',
		type:1,
		disabled:true
		
	},
	{
		name:'车牌号',
		Display:'车牌号',
		type:1
	},
	{
		name:'送货日期',
		Display:'送货日期',
		dateTime:{
			format:'yyyy-MM-dd',
			type:'date'
		},
		type:3,
		must:true
	},
	{
		name:'供应商编码',
		Display:'供应商编码',
		type:1,
		disabled:true,
		priorty:1//采购员
	},
	{
		name:'供应商名称',
		Display:'供应商名称',
		type:1,
		disabled:true,
		priorty:1
	}
]
export const bodyhead=[
	{
		name:'采购订单日期',
		title:'采购订单日期',
		hide:false
	},
	{
		name:'采购订单号',
		title:'采购订单号',
		hide:false
	},
	{
		name:'物料编码',
		title:'物料编码',
		hide:false
	},
	{
		name:'物料名称',
		title:'物料名称',
		hide:false
	},
	{
		name:'规格型号',
		title:'规格型号',
		hide:false
	},
	{
		name:'单位',
		title:'单位',
		hide:false
	},
	{
		name:'本次送货数量',
		title:'本次送货数量',
		hide:false,
		edit:true,
		valueType:'decimal',
		must:true
	},
	{
		name:'订单数量',
		title:'订单数量',
		hide:false
	},
	{
		name:'送货地点',
		title:'送货地点',
		hide:false,
	},
	{
		name:'备注',
		title:'备注',
		hide:false,
	},
	{
		name:'订单跟踪',
		title:'订单跟踪',
		hide:false,
	}
]